import { API_CHAMPIONSHIP, API_URL } from "../ApiPaths";

/** TEAM */
export const getChampionship = async () => {
  const res = await fetch(API_URL + API_CHAMPIONSHIP, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};

export const addNewChampionship = async (tmpNew: string) => {
  const res = await fetch(API_URL + API_CHAMPIONSHIP, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name: tmpNew }),
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }

  return res.json();
};

export const deleteChampionship = async (id: string) => {
  const res = await fetch(`${API_URL}${API_CHAMPIONSHIP}/${id}`, {
    method: "DELETE",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!res.ok) {
    throw new Error("Network response was not ok");
  }
  return res.json();
};
